export default {
	custom: {
		jobEvaluationPoll: {
			diagnosticId: null,
			pollId: null,
			jobs: [],
			selectedJob: {},
		},
	},
};



// WEBPACK FOOTER //
// ./src/modules/polls/store/state.js